import React from "react";
import { FLAT_RATE_PLANS } from "@common/flatRateBilling";
import { FlatRatePlan } from "@common/schemas/billing.schema";
import { currencyFormatterNoFractions } from "@common/helpers/currency";
import { fromIntToMonetary } from "@common/helpers/monetary";
import priceSectionStyles from "./PriceSection.module.scss";

export const defaultRenderPrice = (plan: FlatRatePlan): React.ReactNode => {
    let priceDetails: React.ReactNode;
    let priceDisplay: React.ReactNode;

    if (plan.plan === FLAT_RATE_PLANS.FREE) {
        priceDetails = <>&nbsp;</>;
    } else if (plan.plan === FLAT_RATE_PLANS.FRESHBOOKS) {
        priceDetails = (
            <>
                {currencyFormatterNoFractions.format(
                    fromIntToMonetary(plan.intervalAmountCents),
                )}{" "}
                billed quarterly
            </>
        );
    } else if (plan.plan === FLAT_RATE_PLANS.ENTERPRISE) {
        priceDetails = "Billed monthly";
    } else if (plan.billingInterval === 1) {
        priceDetails = (
            <>
                {currencyFormatterNoFractions.format(
                    fromIntToMonetary(plan.intervalAmountCents),
                )}{" "}
                billed monthly
            </>
        );
    } else {
        priceDetails = (
            <>
                {currencyFormatterNoFractions.format(
                    fromIntToMonetary(plan.intervalAmountCents),
                )}{" "}
                billed {plan.billingInterval === 12 ? "annually" : "quarterly"}
            </>
        );
    }

    if (plan.plan === FLAT_RATE_PLANS.FRESHBOOKS) {
        priceDisplay = (
            <>
                <span className={priceSectionStyles.customPrice}>
                    {currencyFormatterNoFractions.format(
                        fromIntToMonetary(plan.monthlyAmountCents),
                    )}
                </span>
                <small>/m per entity</small>
            </>
        );
    } else if (plan.plan === FLAT_RATE_PLANS.ENTERPRISE) {
        priceDisplay = <>Custom</>;
    } else {
        priceDisplay = (
            <>
                {currencyFormatterNoFractions.format(
                    fromIntToMonetary(plan.monthlyAmountCents),
                )}
                <small>/m</small>
            </>
        );
    }

    return (
        <>
            <span className={priceSectionStyles.price}>{priceDisplay}</span>

            <span className={priceSectionStyles.priceDetails}>
                {priceDetails}
            </span>
        </>
    );
};
